module.exports = __webpack_public_path__ + "img/selected-secretum-secretorum-2.84830681.webp";